export const industryGroups = [
  {
    id: "food-hospitality",
    title: "Food & Hospitality",
    industries: [
      "Grocery Stores",
      "Restaurants",
      "Cafés",
      "Sweet Shops",
      "Hotels",
      "Resorts",
      "Homestays",
    ],
  },
  {
    id: "retail",
    title: "Retail & Commerce",
    industries: [
      "Clothing Stores",
      "Electronics Shops",
      "Medical Stores",
      "Hardware Shops",
    ],
  },
  {
    id: "health",
    title: "Health & Wellness",
    industries: ["Clinics", "Hospitals", "Salons", "Gyms"],
  },
  {
    id: "education-services",
    title: "Education & Services",
    industries: ["Coaching Centers", "Schools", "Travel Agencies"],
  },
  {
    id: "property-auto",
    title: "Property & Automotive",
    industries: ["Real Estate", "Car Showrooms", "Service Centers"],
  },
];
